import { FormControl } from "@angular/forms";
import { conformToMask } from 'angular2-text-mask';
import { Masks } from './masks';

export function versionValidator(control: FormControl) {
    var re = new RegExp(/^0\.\d+\.\d+$/);

    var conformedVersion = conformToMask(
        control.value,
        Masks.version,
        { guide: false }
    )

    if (conformedVersion.conformedValue != undefined && conformedVersion.conformedValue != null && conformedVersion.conformedValue != '' && !re.test(conformedVersion.conformedValue))
        return {
            version: true,
            mensagem:(campo:string)=>`O campo <b>${campo}</b> não é uma Versão válida`
        }
    return null;
}

